// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  font-size: 28px;
}

tr.topMenu td {
  height: 32px;
}

#infoTable tr td:first-child {
  padding-right: 15px;
}

.topHead {
  padding-top: 0;
  margin-top: 0;
  height: 50px;
  font-size: 70%;
}

/**
@media (max-height:  725px ) {
    #informations {
        display: none;
    }
    #informationAltTitle {
        display: block !important;
    }
}



#informationAltTitle {
    display: none;
}

*/
/** affixing **/
.top {
  background-color: #F7F5F2;
  top: 0;
  z-index: 50 !important;
}

.fluid {
  position: relative;
  top: 125px;
}

.semiFluid {
  position: relative;
  top: 125px;
}

.blockBottom {
  position: fixed;
  padding-top: 20px;
}

.bbLeft {
  left: 102px;
  padding: 35px 20px 0 20px;
}

.bbRight {
  padding-right: 40px;
}

.cardEvaluation {
  width: 63px;
  height: 63px;
  margin: 0 auto;
}

.cardEvaluationTitle {
  text-align: center;
}

.modalButton {
  background-color: white;
  color: #111111;
}

.modalButton:hover {
  background-color: #EDF2F5;
}

.h3link {
  cursor: pointer;
}

.h2Pref {
  font-size: 19px;
  font-weight: normal;
  /* line-height: 1.4em; */
  /* padding: 0 0 0.35em 0; */
}

.noRightBorder {
  border-right: none;
}

#typeMenu {
  position: relative;
  top: 13px;
}

.clickMode {
  background-color: #EDF2F5;
}

#typeMenu div {
  padding: 0 3px;
}

#typeMenu div div {
  margin: auto;
  text-align: center;
  cursor: pointer;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.moduleSelected {
  border-bottom: 5px solid #007566;
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  margin: 27px -11px;
  border: 1px solid #EDF2F5;
  background-color: white;
  min-width: 160px;
  z-index: 1;
}

/* Links inside the dropdown */
.dropdown-content a {
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
  display: block;
}

/* Change the background color of the dropdown button when the dropdown content is shown */
.dropdown:hover .dropbtn {
  background-color: #3e8e41;
}

app-people-list-search-filters ::ng-deep .subTitle,
app-jobs-list-search-filters ::ng-deep .subTitle,
app-right-matches-list-search-filters ::ng-deep .subTitle,
app-idw-matrix-search-filters ::ng-deep .subTitle,
app-graphboards-search-filters ::ng-deep .subTitle {
  background-color: white;
}

app-people-list-search-filters ::ng-deep #cardIcon {
  margin-top: auto;
}

app-people-list-search-filters ::ng-deep .filtersPrefs {
  font-size: 14pt;
  margin-top: auto;
  display: block;
}

#mainSubject {
  margin-left: 20px;
  margin-top: 48px;
}

.title {
  font-size: 16pt;
}

#mainSubject div h2 {
  margin: 15px auto 10px auto;
}

.h3link {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/administration/components/administration-user-preferences/administration-user-preferences.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,cAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;AACJ;;AAEA;;;;;;;;;;;;;;;;CAAA;AAkBA,eAAA;AAEA;EACI,yBAAA;EACA,MAAA;EACA,sBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,UAAA;AADJ;;AAIA;EACI,kBAAA;EACA,UAAA;AADJ;;AAIA;EACI,eAAA;EACA,iBAAA;AADJ;;AAIA;EACI,WAAA;EACA,yBAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,cAAA;AADJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,uBAAA;EACA,cAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,eAAA;EACA,mBAAA;EACA,wBAAA;EACA,2BAAA;AADJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,SAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,WAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;AADJ;;AAIA;EACI,gCAAA;AADJ;;AAIA,kEAAA;AACA;EACI,kBAAA;EACA,qBAAA;AADJ;;AAIA,yCAAA;AACA;EACI,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;AADJ;;AAIA,8BAAA;AACA;EACI,kBAAA;EACA,qBAAA;EACA,cAAA;AADJ;;AAIA,oCAAA;AACA;EACI,cAAA;AADJ;;AAIA,0FAAA;AACA;EACI,yBAAA;AADJ;;AAIA;;;;;EAKI,uBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AADJ;;AAIA;EACI,iBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,2BAAA;AADJ;;AAIA;EACI,eAAA;AADJ","sourcesContent":["h1 {\n    font-size: 28px;\n}\n\ntr.topMenu td {\n    height: 32px;\n}\n\n#infoTable tr td:first-child {\n    padding-right: 15px;\n}\n\n.topHead {\n    padding-top: 0;\n    margin-top: 0;\n    height: 50px;\n    font-size: 70%;\n}\n\n/**\n@media (max-height:  725px ) {\n    #informations {\n        display: none;\n    }\n    #informationAltTitle {\n        display: block !important;\n    }\n}\n\n\n\n#informationAltTitle {\n    display: none;\n}\n\n*/\n\n/** affixing **/\n\n.top {\n    background-color: #F7F5F2;\n    top: 0;\n    z-index: 50 !important;\n}\n\n.fluid {\n    position: relative;\n    top: 125px;\n}\n\n.semiFluid {\n    position: relative;\n    top: 125px;\n}\n\n.blockBottom {\n    position: fixed;\n    padding-top: 20px;\n}\n\n.bbLeft {\n    left: 102px;\n    padding: 35px 20px 0 20px;\n}\n\n.bbRight {\n    padding-right: 40px;\n}\n\n.cardEvaluation {\n    width: 63px;\n    height: 63px;\n    margin: 0 auto;\n}\n\n.cardEvaluationTitle {\n    text-align: center\n}\n\n.modalButton {\n    background-color: white;\n    color: #111111;\n}\n\n.modalButton:hover {\n    background-color: #EDF2F5;\n}\n\n.h3link {\n    cursor: pointer;\n}\n\n.h2Pref {\n    font-size: 19px;\n    font-weight: normal;\n    /* line-height: 1.4em; */\n    /* padding: 0 0 0.35em 0; */\n}\n\n.noRightBorder {\n    border-right: none;\n}\n\n#typeMenu {\n    position: relative;\n    top: 13px\n}\n\n.clickMode {\n    background-color: #EDF2F5;\n}\n\n#typeMenu div {\n    padding: 0 3px;\n}\n\n#typeMenu div div {\n    margin: auto;\n    text-align: center;\n    cursor: pointer;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n}\n\n.moduleSelected {\n    border-bottom: 5px solid #007566\n}\n\n/* The container <div> - needed to position the dropdown content */\n.dropdown {\n    position: relative;\n    display: inline-block;\n}\n\n/* Dropdown Content (Hidden by Default) */\n.dropdown-content {\n    display: none;\n    position: absolute;\n    margin: 27px -11px;\n    border: 1px solid #EDF2F5;\n    background-color: white;\n    min-width: 160px;\n    z-index: 1;\n}\n\n/* Links inside the dropdown */\n.dropdown-content a {\n    padding: 12px 16px;\n    text-decoration: none;\n    display: block;\n}\n\n/* Show the dropdown menu on hover */\n.dropdown:hover .dropdown-content {\n    display: block;\n}\n\n/* Change the background color of the dropdown button when the dropdown content is shown */\n.dropdown:hover .dropbtn {\n    background-color: #3e8e41;\n}\n\napp-people-list-search-filters ::ng-deep .subTitle,\napp-jobs-list-search-filters ::ng-deep .subTitle,\napp-right-matches-list-search-filters ::ng-deep .subTitle,\napp-idw-matrix-search-filters ::ng-deep .subTitle,\napp-graphboards-search-filters ::ng-deep .subTitle {\n    background-color: white;\n}\n\napp-people-list-search-filters ::ng-deep #cardIcon {\n    margin-top: auto;\n}\n\napp-people-list-search-filters ::ng-deep .filtersPrefs {\n    font-size: 14pt;\n    margin-top: auto;\n    display: block;\n}\n\n#mainSubject {\n    margin-left: 20px;\n    margin-top: 48px;\n}\n\n.title {\n    font-size: 16pt;\n}\n\n#mainSubject div h2 {\n    margin: 15px auto 10px auto;\n}\n\n.h3link {\n    cursor: pointer;\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
